import LocoSection from './LocoSection'

export default class ElectricLocoSection extends LocoSection  {
    public activePowerConsumption = 0.0
    public electricityFrequency = 0.0
    public refrigerantTemperature = 0.0
    public electricityAmperage = 0.0
    public brakeLinePressure = 0.0
    public brakePressure = 0.0
    public axleBoxes = 0.0
    public tractionTrolleys = 0.0
}